import React from "react";
import { Avatar, Card } from "antd";
import { USABLE_ICONS } from "variables/constants";

const winners = [
  {
    name: "David Martinez",
    initials: "DM",
    position: "DevOps Engineer",
    category: "Innovation",
    country: "Colombia",
    flag: "🇨🇴",
    date: "September 2025",
    icon: "Lightbulb",
    color: "blue",
  },
  {
    name: "Jennifer Lee",
    initials: "JL",
    position: "UX Designer",
    category: "Excellence",
    country: "Philippines",
    flag: "🇵🇭",
    date: "September 2025",
    icon: "Star",
    color: "amber",
  },
  {
    name: "Robert Taylor",
    initials: "RT",
    position: "Sales Director",
    category: "Opportunity",
    country: "India",
    flag: "🇮🇳",
    date: "August 2025",
    icon: "Target",
    color: "green",
  },
];

const PreviousWinnersCard = () => {
  return (
    <div>
      {winners.map((item, index) => {
        const IconComponent =
          item?.icon && USABLE_ICONS[item.icon]
            ? USABLE_ICONS[item.icon]
            : null;

        const colorClass = item?.color;

        return (
          <div key={index} className={`flex rounded-xl winners w-full transition-all my-2 border p-2`}>
            <div className="flex items-center justify-between gap-4 w-full">
              <div className="flex items-center gap-3 flex-1">
                <Avatar
                  size={48}
                  className={`!rounded-full icon-style ${colorClass} flex items-center justify-center`}
                >
                  {item?.initials}
                </Avatar>

                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <h4 className="font-semibold text-[14px] title-text">
                      {item?.name}
                    </h4>

                    <span
                      className={`status-indicator ${colorClass} `}
                    >
                      {item?.category}
                    </span>
                  </div>

                  <p className="text-[12px] muted-text">
                    {item?.position}
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="text-right">
                  <div className="flex items-center gap-1 mb-1">
                    <span className="text-[12px]">{item?.flag}</span>
                    <span className="text-[11px] muted-text">
                      {item?.country}
                    </span>
                  </div>

                  <p className="text-[11px] muted-text">
                    {item?.date}
                  </p>
                </div>

                <div
                  className={`w-8 h-8 icon-style ${colorClass} shadow-lg flex items-center justify-center`}
                >
                  {IconComponent &&
                    React.createElement(IconComponent, {
                      className: "w-4 h-4 text-white",
                    })}
                </div>
              </div>

            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PreviousWinnersCard;